import { RouterType } from '@online-webinar/router';
import { ChapterManagement } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/chapters'].update({
        staticData: { title: { page: 'Content.Chapters.PageHeading', forWebinar: true } },
        component: authGuard(ChapterManagement, { canBroadcast: true })
    });
};
